import {ENDPOINT_VERSIONS} from './_endpoint-versions';

export const SEATS_CREATE_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/seats/create`;
